<template>
  <div class="user-profile">
    <!-- Logged-in state -->
    <template v-if="userProfileStore.isLoggedIn">
      <div class="avatar-circle" @click="toggleMenu">
        {{ userProfileStore.profile?.initials }}
      </div>
      <div class="user-text" @click="toggleMenu">
        <span class="name"
          >{{ userProfileStore.profile?.name }} {{ userProfileStore.profile?.surname }}</span
        >
        <span class="email">{{ userProfileStore.profile?.email }}</span>
      </div>
      <UserProfileMenu
        v-if="isMenuOpen"
        :isLoggedIn="userProfileStore.isLoggedIn"
        @logout="logout"
      />
    </template>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue'
import { useUserProfileStore } from '../stores/userProfileStore'
import { useAppStore } from '../stores/appStore'
import { useRouter } from 'vue-router'
import { LoginRequired } from '../types/app/loginRequired'
import UserProfileMenu from './UserProfileMenu.vue'
import axios from 'axios'
import { useAidaSessionStore } from '../stores/aidaSessionStore'

const router = useRouter()

const emit = defineEmits<{
  (e: 'login-click'): void
  (e: 'logout-click'): void
}>()

const userProfileStore = useUserProfileStore()
const aidaSessionStore = useAidaSessionStore()
const appStore = useAppStore()
const isMenuOpen = ref(false)
const credentialsBase64 = aidaSessionStore.authBase64()
// const lR = ref(false)

onMounted(async () => {
  const loginRequired = appStore.configuration?.login.isLoginRequired
  console.log(`UserProfile - login_mode from appStore = ${loginRequired}`)
  // if (loginRequired === LoginRequired.Always) {
  //   lR.value = true
  // } else {
  //   lR.value = false
  // }
})

async function logout() {
  try {
    await axios.delete(`${import.meta.env.VITE_BACKEND_BASE_URL}/user/me/session`, {
      headers: {
        Authorization: `${credentialsBase64}`,
        'Authorization-Token': `Bearer ${userProfileStore.profile?.idToken}`,
      },
    })
  } catch (err) {
    console.error('Backend logout failed:', err)
    // continue anyway — user should still be logged out locally
  }

  console.log('UserProfileMenu - Logout clicked')
  userProfileStore.clearUserProfile()
  emit('logout-click')
  isMenuOpen.value = false
  if (appStore.configuration?.login.isLoginRequired === LoginRequired.Always) {
    router.push({ name: 'login' })
  } else {
    router.push({ name: 'main' })
  }
}

function toggleMenu() {
  console.log('UserProfileMenu - Toggle Menu')
  isMenuOpen.value = !isMenuOpen.value
}
</script>

<style scoped lang="scss">
.user-profile {
  display: flex;
  align-items: center;
  padding: 8px;
  font-family: 'Noto Sans', sans-serif;
  position: relative;
}

.user-text {
  display: flex;
  flex-direction: column; /* stack vertically */
  margin-left: 8px; /* spacing from avatar */
}

.name {
  font-weight: 600;
  font-size: 14px;
  color: var(--text-color);
}

.email {
  font-size: 11px;
  color: var(--light-color);
}

.avatar-circle {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background-color: #1976d2; /* blue for logged in */
  color: var(--background-color);
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  font-size: 16px;
  text-transform: uppercase;
}

.avatar-placeholder {
  background-color: #9e9e9e; /* grey for logged out */
}

.dots {
  position: relative;
  width: 4px;
  height: 4px;
  background: var(--background-color);
  border-radius: 50%;
}

.dots::before,
.dots::after {
  content: '';
  position: absolute;
  left: 0;
  width: 4px;
  height: 4px;
  background: var(--background-color);
  border-radius: 50%;
}

.dots::before {
  top: -6px; /* dot above */
}

.dots::after {
  top: 6px; /* dot below */
}

.login-btn {
  background: none;
  border: none;
  color: #333333;
  padding: 6px 12px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
}

.login-btn:hover {
  color: #000000;
}
</style>
